import {
  ISequenceFieldConfigurationClient,
  ISequenceFieldConfigurationServer,
} from "./interface";

export const transformSequenceFieldConfigClientToServer = (
  fieldConfigClient: ISequenceFieldConfigurationClient
): ISequenceFieldConfigurationServer => {
  const {
    prefix,
    postfix,
    sequenceType,
    numericSequenceCount,
    hideFromVisiblity,
    generateSequenceByWorkflow,
    defaultSequenceValue,
  } = fieldConfigClient;
  const fieldConfigServer = {
    prefix: prefix,
    postfix: postfix,
    sequenceType: sequenceType,
    numericSequenceCount: numericSequenceCount,
    hideFromVisiblity: hideFromVisiblity,
    generateSequenceByWorkflow: generateSequenceByWorkflow,
    defaultSequenceValue: defaultSequenceValue,
  };
  return fieldConfigServer;
};

export const transformSequenceFieldConfigServerToClient = (
  fieldConfigServer: ISequenceFieldConfigurationServer
): ISequenceFieldConfigurationClient => {
  const {
    prefix,
    postfix,
    sequenceType,
    numericSequenceCount,
    hideFromVisiblity,
    generateSequenceByWorkflow,
    defaultSequenceValue,
  } = fieldConfigServer;
  const fieldConfigClient = {
    prefix: prefix,
    postfix: postfix,
    sequenceType: sequenceType,
    numericSequenceCount: numericSequenceCount,
    hideFromVisiblity: hideFromVisiblity,
    generateSequenceByWorkflow: generateSequenceByWorkflow,
    defaultSequenceValue: defaultSequenceValue,
  };
  return fieldConfigClient;
};
